"use client";

import { motion } from "framer-motion";
import {
  MousePointerClick,
  Megaphone,
  LineChart,
  CheckCircle2,
  ArrowUpRight,
} from "lucide-react";

export function Services() {
  const services = [
    {
      icon: <MousePointerClick className="w-6 h-6 text-[#D4A574]" />,
      title: "Tráfego Pago",
      description:
        "Anúncios cirúrgicos no Meta Ads e Google Ads para capturar o cliente no momento exato de compra.",
      benefits: [
        "Campanhas de alta conversão",
        "Otimização diária de ROI",
        "Relatórios transparentes",
        "Foco em captação de leads",
      ],
    },
    {
      icon: <Megaphone className="w-6 h-6 text-[#B8845A]" />,
      title: "Branding & Posicionamento",
      description:
        "Construímos uma presença magnética para sua marca que gera autoridade e confiança nas plataformas digitais.",
      benefits: [
        "Conteúdo estratégico",
        "Design de alto impacto",
        "Crescimento orgânico",
        "Autoridade de marca",
      ],
    },
    {
      icon: <LineChart className="w-6 h-6 text-[#E0B88A]" />,
      title: "Funis de Vendas",
      description:
        "Estruturamos todo o seu funil para garantir que cada clique se transforme em faturamento real.",
      benefits: [
        "Landing Pages otimizadas",
        "CRO (Conversão)",
        "E-mail marketing",
        "Scripts de vendas",
      ],
    },
  ];

  return (
    <section id="services" className="py-24 relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-[#C9956B]/40 to-transparent" />

      <div className="container mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-[12px] font-medium uppercase tracking-widest text-[#D4A574] mb-4 block"
          >
            O que fazemos
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold tracking-tight mb-4"
          >
            Nossas especialidades
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-[15px] text-zinc-400"
          >
            Combinamos dados, criatividade e estratégia para gerar resultados
            mensuráveis e consistentes.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="group flex flex-col p-6 rounded-xl bg-white/[0.02] border border-white/[0.06] hover:border-[#C9956B]/30 hover:bg-white/[0.04] transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-5">
                <div className="w-11 h-11 rounded-lg bg-white/[0.05] flex items-center justify-center group-hover:bg-[#C9956B]/10 transition-colors">
                  {service.icon}
                </div>
                <ArrowUpRight className="w-4 h-4 text-zinc-600 group-hover:text-[#D4A574] transition-colors" />
              </div>

              <h3 className="text-[16px] font-semibold text-white mb-2">
                {service.title}
              </h3>
              <p className="text-[13px] text-zinc-500 leading-relaxed mb-6 flex-grow">
                {service.description}
              </p>

              <ul className="space-y-2.5 pt-5 border-t border-white/[0.04]">
                {service.benefits.map((benefit, i) => (
                  <li
                    key={i}
                    className="flex items-center gap-2.5 text-zinc-500"
                  >
                    <CheckCircle2 className="w-3.5 h-3.5 text-[#C9956B]/70 shrink-0" />
                    <span className="text-[13px]">{benefit}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
